import { Component, ReactNode } from 'react'
import { ModalNodeProps } from '../../../components/modal.component'
import { OperatingTime, VendorInfoDto } from '../../../../definition'
import { asyncGetListVendors, asyncUpdateVendorOperating } from '../../../../services/vendors.service'
import { Button, Select, Switch } from 'antd'
import { TimePicker } from 'antd'
import moment, { Moment } from 'moment'
import { preventMouseEvent } from '../../../../utils'
import { toast } from 'react-toastify'

const format = 'HH:mm'

const defaultTime = [
  { name: 'Monday', enable: false },
  { name: 'Tuesday', enable: false },
  { name: 'Wednesday', enable: false },
  { name: 'Thursday', enable: false },
  { name: 'Friday', enable: false },
  { name: 'Saturday', enable: false },
  { name: 'Sunday', enable: false }
]

export class ConfigOperatingDay extends Component<
  ModalNodeProps,
  {
    listVendors: VendorInfoDto[]
    selectVendor?: VendorInfoDto
    operatingTime: OperatingTime[]
  }
> {
  componentDidMount(): void {
    this.fetchVendors()
  }

  async fetchVendors() {
    const vendors = (await asyncGetListVendors({ all: true }))?.items || []
    this.setState({ listVendors: vendors })
  }

  updateConfigure(day: string, type: 'begin' | 'end' | 'lastBookingSlot', value: Moment | null) {
    if (value && this.state.selectVendor?.operatingTime) {
      const time = moment(value).format('HH:mm').toString()
      const newConfig = [...this.state.selectVendor?.operatingTime].map((operation) => {
        if (operation.name !== day) {
          return operation
        } else {
          let newOperation = { ...operation }
          if (type === 'begin') newOperation.begin = time
          if (type === 'end') newOperation.end = time
          if (type === 'lastBookingSlot') newOperation.lastBookingSlot = time

          return newOperation
        }
      })

      this.setState({
        selectVendor: {
          ...this.state.selectVendor,
          operatingTime: newConfig
        }
      })
    }
  }

  updateStatus(day: string, status: boolean) {
    if (this.state.selectVendor?.operatingTime) {
      const newConfig = [...this.state.selectVendor?.operatingTime].map((operation) => {
        if (operation.name !== day) {
          return operation
        } else {
          let newOperation = {
            ...operation,
            enable: status,
            begin: operation.begin || '08:00',
            end: operation.end || '23:00',
            lastBookingSlot: operation.lastBookingSlot || '20:00'
          }
          return newOperation
        }
      })

      this.setState({
        selectVendor: {
          ...this.state.selectVendor,
          operatingTime: newConfig
        }
      })
    }
  }

  async onSubmit() {
    if (this.state?.selectVendor?.id) {
      let error = ''
      this.state?.selectVendor.operatingTime.forEach((operation) => {
        if (
          moment
            .duration(moment(operation.lastBookingSlot, 'HH:mm').diff(moment(operation.begin, 'HH:mm')))
            .asMinutes() < 0
        ) {
          error += `${operation.name}: Last booking slot must after Start time\n`
        }
        if (
          moment.duration(moment(operation.lastBookingSlot, 'HH:mm').diff(moment(operation.end, 'HH:mm'))).asMinutes() >
          0
        ) {
          error += `${operation.name}: Last booking slot must before  End time\n`
        }
      })

      if (error) {
        toast.error(<div style={{ whiteSpace: 'pre-line' }}>{error}</div>)
        return
      }
      try {
        await asyncUpdateVendorOperating(
          this.state.selectVendor?.id,
          this.state?.selectVendor.operatingTime.map((ope) => {
            return {
              ...ope,
              begin: ope.begin ? moment(ope.begin, 'HH:mm').format('hh:mmA') : undefined,
              end: ope.end ? moment(ope.end, 'HH:mm').format('hh:mmA') : undefined,
              lastBookingSlot: ope.lastBookingSlot ? moment(ope.lastBookingSlot, 'HH:mm').format('hh:mmA') : undefined
            }
          })
        )
        await this.fetchVendors()
        this.props.onDone?.()
        toast.success('Saved!')
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  render(): ReactNode {
    const filterOption = (input: string, option?: { label?: string; value?: string }) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    return (
      <div className='customer-modal config-operating-day'>
        <form onSubmit={this.onSubmit}>
          <div className='customer-modal-basic-info '>
            <div className='row'>
              <div className='col-12'>
                <div className='label-input'>
                  <label>Vendor:</label>
                  <Select
                    placeholder='Select'
                    className='role'
                    value={this.state?.selectVendor?.id}
                    options={this.state?.listVendors?.map((vendor) => {
                      return {
                        value: vendor.id,
                        label: vendor.name
                      }
                    })}
                    onChange={(value) => {
                      const vendor = this.state.listVendors.find((vendor) => vendor.id === value)
                      if (vendor) {
                        this.setState({
                          selectVendor: {
                            ...vendor,
                            operatingTime: vendor?.operatingTime
                              ? vendor?.operatingTime.map((ope) => {
                                  return {
                                    ...ope,
                                    begin: ope.begin ? moment(ope.begin, 'hh:mmA').format('HH:mm') : undefined,
                                    end: ope.end ? moment(ope.end, 'hh:mmA').format('HH:mm') : undefined,
                                    lastBookingSlot: ope.lastBookingSlot
                                      ? moment(ope.lastBookingSlot, 'hh:mmA').format('HH:mm')
                                      : undefined
                                  }
                                })
                              : defaultTime
                          }
                        })
                      }
                    }}
                    filterOption={filterOption}
                    showSearch
                  />
                </div>
              </div>
            </div>
            {this.state?.selectVendor &&
              this.state?.selectVendor?.operatingTime?.map((operation) => {
                return (
                  <div key={operation.name} className='row'>
                    <div className='col-12'>
                      <div className='label-input'>
                        <label>
                          <div className='toggle-rest'>
                            {operation.name}{' '}
                            <Switch
                              style={{ marginLeft: 8 }}
                              onChange={(checked) => {
                                this.updateStatus(operation.name, checked)
                              }}
                              checked={operation.enable}
                            />
                          </div>
                        </label>
                        <div className='configure-operation-item'>
                          <div className='label-input'>
                            <label>Start time</label>
                            <TimePicker
                              value={operation.begin ? moment(operation.begin, format) : undefined}
                              format={format}
                              onChange={(value) => {
                                this.updateConfigure(operation.name, 'begin', value)
                              }}
                              minuteStep={30}
                              disabledTime={() => {
                                return {
                                  disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7]
                                }
                              }}
                            />
                          </div>
                          <div className='label-input'>
                            <label>End time</label>
                            <TimePicker
                              value={operation.end ? moment(operation.end, format) : undefined}
                              format={format}
                              minuteStep={30}
                              onChange={(value) => {
                                this.updateConfigure(operation.name, 'end', value)
                              }}
                            />
                          </div>
                          <div className='label-input'>
                            <label>Last booking slot</label>
                            <TimePicker
                              value={operation.lastBookingSlot ? moment(operation.lastBookingSlot, format) : undefined}
                              format={format}
                              onChange={(value) => {
                                this.updateConfigure(operation.name, 'lastBookingSlot', value)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            {this.state?.selectVendor && (
              <div className='row' style={{ justifyContent: 'center' }}>
                <label className='label-input'>
                  <Button className='create-customer-btn' onClick={preventMouseEvent(this.onSubmit.bind(this))}>
                    Save
                  </Button>
                </label>
              </div>
            )}
          </div>
        </form>
      </div>
    )
  }
}
